import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin-top: 10px;
  box-sizing: border-box;
`;

export const TabContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SectionBlock = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  background-color: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
  padding: 24px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 16px 14px;
    border-radius: 12px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }
`;

export const SectionTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: var(--dark-gray);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SectionSubtitle = styled.p`
  font-size: 13px;
  color: var(--gray);
  margin: 0;
`;

export const BlockHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;

    & > * {
      width: 100% !important;
      flex: 1;
    }

    & > button,
    & > div > button,
    button {
      width: 100% !important;
      justify-content: center;
    }
  }
`;
